globalThis.appVisitor = globalThis.appVisitor || {};

appVisitor.ElementMenu = (function() {
    function ElementMenu($html) {
      this.$html = $html;
      this.$body = $('body');
      this.$secondaryMenu = $('.secondary_menu_fixed');
      this.$secondaryMenuUl = this.$secondaryMenu.find('.menu-level-0 > ul.menu-tabs');
      this.$mainMenu = $('.element-menu').first();
      this.$topBar = $('#top-bar');
      this.fixedMainMenuEnabled = this.$body.hasClass('menu_fixed');
      this.fixedTopBarEnabled = this.$body.hasClass('top_bar_fixed');
      this.verticalMainMenu = this.$mainMenu.children().first().hasClass('menu-vertical');
      this.menuTabsZone = this.$secondaryMenu.children('div:first').hasClass('menu-tabs-zone');
      this.$centerInner = $('#center_inner');

      if(this.$secondaryMenu.length) {
        this.secondaryMenuOffsetTop = this.$secondaryMenu.offset().top;
        this.secondaryMenuOffsetLeft = this.$secondaryMenu.offset().left;
      }
      if(this.$secondaryMenuUl.length) {
        this.secondaryMenuUlWidth = this.$secondaryMenu.width();
      }

      if(this.$topBar.length) {
        this.topBarHeight = this.$topBar[0].offsetHeight;
      }

      if(this.$centerInner.length) {
        this.centerInnerLeft  = this.$centerInner.offset().left;
        this.centerInnerWidth = this.$centerInner[0].offsetWidth;
      }
    }

    ElementMenu.prototype = {
      init: function() {
        var _this = this;

        if($("body").hasClass("view-visitor")) {
          _this.initFixedMenu();
          _this.triggerFolderEvents();
        } else {
          _this.initOpenFolderButtons();
        }
      },
      initFixedMenu: function() {
        var _this = this;

        $(document).scroll(function() {
          var $fixedMainMenu = $('.menu_is_fixing') || $('header_wrapper');
          var fixedTopBarHeight = _this.fixedTopBarEnabled ? _this.$topBar.outerHeight() : 0;
          var fixedMainMenuHeight = (_this.fixedMainMenuEnabled && !_this.verticalMainMenu) ? $fixedMainMenu.outerHeight() : 0;
          var minFixedMenuOffsetTop = $(window).scrollTop() + fixedTopBarHeight + fixedMainMenuHeight;
          var left = _this.verticalMainMenu ? _this.centerInnerLeft : 0;
          var width = _this.verticalMainMenu ? _this.centerInnerWidth : '100%';

          if(_this.secondaryMenuOffsetTop <= minFixedMenuOffsetTop) {
            _this.$secondaryMenu.css({
              top        : fixedTopBarHeight + fixedMainMenuHeight,
              position   : 'fixed',
              left       : left,
              width      : width,
            }, 100).addClass('secondary_menu_is_fixing');

            if(!_this.verticalMainMenu && _this.menuTabsZone) {
              _this.$secondaryMenuUl.css({
                width      : _this.secondaryMenuUlWidth,
                marginLeft : '' + _this.secondaryMenuOffsetLeft + 'px'
              }, 100);
            }
          } else {
            _this.$secondaryMenu.css({
              position : 'static',
              width    : 'auto'
            }).removeClass('secondary_menu_is_fixing');

            if(!_this.verticalMainMenu) {
              _this.$secondaryMenuUl.css({
                width      : 'auto',
                marginLeft : 'auto'
              }, 100);
            }
          }
        })
      },
      initOpenFolderButtons: function() {
        var _this = this;

        _this.$html.on('click', '.open-folder-btn', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var $this = $(this);
          var $activeFolders = $('.menu-folder.active');

          var $btnOpenFolder = $this.find('.btn-open-folder');
          var $btnCloseFolder = $this.find('.btn-close-folder');
          var targetFolderId = $this.data('target-folder-id');
          var $targetFolder = _this.$html.find(`[data-folder-id="${targetFolderId}"]`);

          $targetFolder.toggleClass('active');
          var isActive = $targetFolder.hasClass('active');

          $('body').trigger('menu:open-folder-triggered', {
            targetFolder: $targetFolder,
            isActive: isActive,
          });

          if(isActive) {
            $('body').addClass('menu-folder-open');

            $activeFolders.each(function() {
              $(this).parent().find('.menu-tab').find('.btn-close-folder').hide();
              $(this).parent().find('.menu-tab').find('.btn-open-folder').show();
              $(this).parent().find('.open-folder-btn').attr('title', appAdmin.lang.t('context.menu.openFolder'))
              $(this).removeClass('active');
            });

            $btnOpenFolder.hide();
            $btnCloseFolder.show();
            $this.attr('title', appAdmin.lang.t('context.menu.closeFolder'));
          } else {
            $('body').removeClass('menu-folder-open');
            $btnOpenFolder.show();
            $btnCloseFolder.hide();
            $this.attr('title', appAdmin.lang.t('context.menu.openFolder'));
          }
        });
      },
      triggerFolderEvents: function() {
        var _this = this;

        _this.$html.on('mouseenter mouseleave', '.menu-tab-container:has(.menu-folder)', function(e) {
          var $this = $(this);
          var $targetFolder = $this.find('.menu-folder');
          var isActive = e.type === 'mouseenter';

          $('body').trigger('menu:open-folder-triggered', {
            targetFolder: $targetFolder,
            isActive: isActive
          });
        });
      }
    }

    return ElementMenu;
})();
